import {
  AnyAssetSubType,
  AssetParams,
  AssetTypeURI,
  DraftMonitorProfile,
} from '@mss/mss-component-library';

export const initialValues: (
  assetType: AssetParams['assetType'],
  hasSharedMonitors?: boolean
) => DraftMonitorProfile = (assetType, hasSharedMonitors) => ({
  name: '',
  asset_type: assetType,
  assetSubType:
    subtypeOptions[assetType].length === 1 || !hasSharedMonitors || assetType === 'network'
      ? subtypeOptions[assetType][0]
      : '-',
  monitorsToEnable: [],
});

export const subtypeOptions: Record<AssetTypeURI, AnyAssetSubType[]> = {
  compute: ['windows_agentless'],
  field: [],
  plcdcs: ['avr', 'bcv', 'fcn', 'fcs', 'scs', 'wac', 'hmi_stn', 'siemens_generic', 'siemens_s7'],
  network: ['firewall', 'switch', 'router', 'timeserver'],
  env: ['odu'],
  security: [
    'trellix_epo',
    'whatsup_gold',
    'claroty',
    'nozomi',
    'wsus',
    'veeam',
  ],
  analyzermanagement: ['calsys', 'aaims'],
  assetmanagement: ['prm', 'isae'],
  virtualization: ['microsoft_hyper_v'],
  control: ['centum_vp'],
};
